import { InjectionToken } from '@angular/core';
import { BrowserWindowType } from './browser-window.service';

/**
 * Interface for app configuration object.
 */
export interface ConfigObject {
  allowedBrowserWindowTypes: BrowserWindowType[];
  api: { [endpoint: string]: string };
  appName: string;
}

/**
 * App configuration has its value set in `app.module.ts`, where it is defined as
 * a provider.
 */
export let CONFIG = new InjectionToken<ConfigObject>('ConfigService');
